import { useSuspenseQuery } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { ValidationHistoryContent } from '@feature/validation/ValidationHistoryContent';

import { getEvaluationItemValidationHistoryOptions } from './model/EvaluationItemValidationModel';

interface EvaluationItemValidationHistoryProps {
  itemId: Id;
  defaultIsCollapsed?: boolean;
}

export function EvaluationItemValidationHistory({ itemId, defaultIsCollapsed }: EvaluationItemValidationHistoryProps) {
  const { data: history } = useSuspenseQuery(getEvaluationItemValidationHistoryOptions(itemId));

  return (
    <ValidationHistoryContent
      history={history}
      defaultIsCollapsed={defaultIsCollapsed}
    />
  );
}
